import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

const SectionBlockerWrapper = ({ blocked, children, showMessage = true }) => {
  return (
    <Box position="relative" width="100%">
      {children}
      {blocked && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bgcolor="rgba(255,255,255,0.6)"
          zIndex={5}
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            cursor: 'not-allowed',
          }}
        >
          {showMessage && (
            <Typography variant="h6" align="center" color="textSecondary">
              Stai modificando un’altra sezione. Salva per proseguire
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

SectionBlockerWrapper.propTypes = {
  blocked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  showMessage: PropTypes.bool,
};

export default SectionBlockerWrapper;
